import {fetchForms} from '@gauged/gauged-js';
import apiClient from 'api';

export async function forms({ params }: {request: Request, params: {name?: string}}) {
    return fetchForms(apiClient, {name: params.name});
}
